import { ReferenceDataValidationError } from '../../domain/errors/ReferenceDataValidationError';
import { selectedRoadSectionsQuery } from '../../reference/queries';
import { updatedRoadSections } from '../../reference/state';
import { createCommand } from '../../utils';
import type { EditableField, EditResult, EditValue } from '../edit';
import { editDialogClosed, noticeSet } from '../state';

// Saves one referential field on every selected section, through the same endpoint as the /reference table.
// The updated sections replace the loaded ones, so the map recolors and the panels refresh at once.
// Unlike the table's command it reports failure to the dialog instead of opening a global modal.
export const EditReferenceFieldCommand = createCommand<{ field: EditableField; value: EditValue }, EditResult>(
    'MAP_V2/EDIT_REFERENCE_FIELD',
    async ({ field, value }, { dispatch, getState, extra }) => {
        const ids = selectedRoadSectionsQuery(getState()).map((section) => section.id);
        try {
            const updated = await extra.externalReference.editRoadSections(ids, { [field]: value });
            dispatch(updatedRoadSections(updated));
            dispatch(editDialogClosed());
            dispatch(noticeSet({ field, count: ids.length }));

            return { status: 'ok' };
        } catch (error) {
            if (error instanceof ReferenceDataValidationError) {
                return { status: 'invalid', field: error.field };
            }

            return { status: 'error' };
        }
    },
);
